import { Button } from 'antd'
import FleetForm from './FleetForm'
import { useTranslation } from 'next-i18next'
import { PlusOutlined } from '@ant-design/icons'
import React, { useEffect, useState } from 'react'
import { showNotification } from 'src/core/helpers'
import { fleetListColumns } from 'src/core/table-columns'
import { getFleetSelector, resetFileSelector } from 'src/features'
import { CustomCard, CustomModal, CustomTable } from 'src/components'
import { getFleetList } from 'src/features/manage-cabify-process/actions'
import { useAppDispatch, useAppSelector, useWindowSize } from 'src/app/hooks'

const FleetList: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { loading, data, successDelete, successCreate, error } = useAppSelector(getFleetSelector)
  const [isModalFleetVisible, setIsModalFleetVisible] = useState(false)
  const { isMobile } = useWindowSize()

  useEffect(() => {
    if (successDelete || successCreate) {
      dispatch(getFleetList())
    }
    if (error) {
      showNotification('error', t('Auth.CompleteInfo.SomeError'))
      dispatch(resetFileSelector)
    }
  }, [dispatch, successDelete, successCreate, error, t])

  useEffect(() => {
    dispatch(getFleetList())
  }, [dispatch])

  return (
    <div className={isMobile && 'mt-5'}>
      <CustomCard
        style={{ minHeight: '28.5rem' }}
        cardTitle={t('Cabify.Fleets')}
        loading={loading}
        extra={
          <Button
            type='primary'
            shape='round'
            className='radius-100'
            icon={<PlusOutlined />}
            onClick={() => setIsModalFleetVisible(true)}
          > {t('Cabify.AddFleet')} </Button>}
      >
        <CustomTable
          pageSize={5}
          size='small'
          columns={fleetListColumns}
          dataSource={data}
        />
      </CustomCard>
      <CustomModal
        width={450}
        footer={null}
        destroyOnClose
        title={t('Cabify.AddFleet')}
        onCancel={() => setIsModalFleetVisible(false)}
        visible={isModalFleetVisible}
      >
        <FleetForm handleCancel={() => setIsModalFleetVisible(false)} />
      </CustomModal>
    </div>
  )
}

export default FleetList
